package com.kanati.shared.report

import kotlinx.serialization.Serializable

@Serializable
data class DailySalesReportRow(
    val date: String,
    val subtotalAmount: Long,
    val taxAmount: Long,
    val totalAmount: Long,
)

@Serializable
data class TopProductReportRow(
    val productId: String,
    val productName: String,
    val unitsSold: Long,
    val grossSalesAmount: Long,
)

@Serializable
data class InventoryReportRow(
    val productId: String,
    val productName: String,
    val quantityOnHand: Int,
    val updatedAt: String?,
)

@Serializable
data class TicketSalesReportRow(
    val eventId: String,
    val eventName: String,
    val ticketTierId: String,
    val ticketTierName: String,
    val ticketsSold: Long,
    val grossSalesAmount: Long,
)

@Serializable
data class TicketValidationActivityReportRow(
    val validationRecordId: String,
    val eventId: String,
    val eventName: String,
    val ticketId: String? = null,
    val ticketCode: String,
    val ticketTierId: String? = null,
    val ticketTierName: String? = null,
    val outcome: String,
    val ticketStatusAfter: String,
    val scannedAt: String,
    val recordedAt: String,
)
